import { makeFieldValueDbModule } from '../makeFieldValueDbModule';
import { clear as circumstancesServiceClear } from './circumstancesService';
import { makeClearPublisher } from 'serviceWorker/broadcasts/publishers';
import { fieldValueContracts } from 'shared/domain/fieldValue/fieldValueContracts';
import { EditableFieldValuesEntityName } from 'shared/domain/fieldValue/fields';

export const {
  clear,
  quantity,
  get,
  getOne,
  addBatch,
  updateBatch,
  removeBatch,
} = makeFieldValueDbModule({
  tableName: 'circumstances',
  serviceTableName: 'circumstancesService',
  serviceClearFunction: circumstancesServiceClear,
  broadcastClearFunction: makeClearPublisher(fieldValueContracts[EditableFieldValuesEntityName.circumstances]),
});
